import { useState } from "react";
import { Dialog, VisuallyHidden } from "radix-ui";

import { IsoLogo } from "@/assets";
import { icons, IconWrapper } from "@/shared/ui";
import { Sidebar } from "./sidebar";

export const ResponsiveSidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      <Dialog.Root open={sidebarOpen} onOpenChange={setSidebarOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 z-50 bg-gray-800/50 backdrop-blur-xs data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0" />
          <Dialog.Content className="fixed inset-y-0 left-0 z-50 h-full w-fit gap-4 border-r border-gray-700 bg-black shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=closed]:animate-out data-[state=closed]:slide-out-to-left data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=open]:slide-in-from-left sm:max-w-sm">
            <VisuallyHidden.Root>
              <Dialog.Title>LevelsRx navigation</Dialog.Title>
              <Dialog.Description>Mobile sidebar</Dialog.Description>
            </VisuallyHidden.Root>
            <Sidebar onCloseSidebar={() => setSidebarOpen(false)} />
            <Dialog.Close className="absolute top-6 right-6 rounded-xs transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none">
              <IconWrapper size="md">
                <icons.XMark className="stroke-white" />
              </IconWrapper>

              <span className="sr-only">Close</span>
            </Dialog.Close>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>

      <div className="z-40 flex h-12 shrink-0 items-center justify-between gap-x-6 bg-primary-50 px-4 shadow-xs sm:px-6 lg:hidden lg:px-8">
        <button
          type="button"
          className="-m-2.5 p-2.5 text-white xl:hidden"
          onClick={() => setSidebarOpen(true)}
        >
          <span className="sr-only">Open sidebar</span>

          <icons.Bars3 className="size-5 text-primary-950" aria-hidden="true" />
        </button>

        <IsoLogo className="size-7" />
      </div>
    </>
  );
};
